module.exports = __webpack_public_path__ + "img/sf-korea-logo.a3b88a8.png";